import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import {
  associarDevolucaoParcialOrdemColeta,
  atualizarNumNfEntrega,
  getDevolucaoParcialPendentes,
} from '../../../../services/api/https/ordem-coleta/ordem-coleta.http'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import {
  Btn,
  Cnpj,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomModal,
  InputNumeroInteiro,
  Loading,
  TextBtn,
  ThreeDots,
} from '../../../../components'
import { tableCellCentered } from '../../../../assets/js/styles'
import { error } from '../../../../assets/js/colors'
import { selectOcorrencia } from '../../../../store/actions/ordem-coleta.actions'
import { renderVolumeUnitsCell } from '../ordem-coleta-volume-and-units.helper'

function DevolucaoParcialPendente({
  ordemColetaId,
  tpId,
  companyId,
  dispatch,
  history,
  selectedIdentifier,
  pInicial,
  pFinal,
}) {
  // Vars

  // Hooks
  const [isLoading, setIsLoading] = useState(true)
  const [btnAssociarIsLoading, setBtnAssociarIsLoading] = useState(false)
  const [devolucoes, setDevolucoes] = useState([])
  const [globalFilter, setGlobalFilter] = useState(selectedIdentifier)
  const [showModalNfEntrega, setShowModalNfEntrega] = useState(false)
  const [selectedDevolucao, setSelectedDevolucao] = useState(null)
  const [selecionarTodos, setSelecionarTodos] = useState(false)

  useEffect(() => {
    getDevolucoesParciais()
  }, [pInicial, pFinal])

  // Events
  const onItemClicked = (devolucao, checked) => {
    const index = devolucoes.findIndex(d => d.delivery_id === devolucao.delivery_id)
    if (index !== -1) {
      const d = [...devolucoes]
      d[index].selected = checked
      setDevolucoes(d)
    }
  }

  const onMenuItemClicked = (item, devolucao) => {
    const { identifier, razao_social, delivery_id, delivery_step_id, client_id } = devolucao
    dispatch(selectOcorrencia(1, identifier))
    switch (item) {
      case 'Anexar Canhoto':
        history.push('/main/ordemcoleta/anexar-canhoto', { delivery_id })
        break
      case 'NF Devol. Parcial':
        history.push('/main/ordemcoleta/notas-fiscais-cliente', {
          delivery_id,
          step_id: delivery_step_id,
          client_id,
        })
        break
      case 'Ocorrências':
        history.push('/main/ordemcoleta/ocorrencias-por-entrega', {
          delivery_id,
          identifier,
          razao_social,
          delivery_step_id,
        })
        break
      default:
        break
    }
  }

  const onNfEntregaIncluir = devolucao => {
    setSelectedDevolucao(devolucao)
    setShowModalNfEntrega(true)
  }

  const onModalNotaFiscalEntregaSuccess = (deliveryId, nf) => {
    const index = devolucoes.findIndex(d => d.delivery_id === deliveryId)
    if (index !== -1) {
      const newDevs = [...devolucoes]
      newDevs[index].invoice_number_entrega = nf
      setDevolucoes(newDevs)
    }
    setShowModalNfEntrega(false)
  }

  const onModalNotaFiscalEntregaError = error => {
    dispatch(showModalNfEntrega(null, error))
    setShowModalNfEntrega(false)
  }

  const onModalNotaFiscalEntregaClose = () => {
    setShowModalNfEntrega(false)
  }

  const onBtnAssociarClick = async () => {
    try {
      setBtnAssociarIsLoading(true)
      const devolucoesSelecionadas = devolucoes.filter(d => d.selected)
      const deliveries_ids = devolucoesSelecionadas.map(d => d.delivery_id)
      await associarDevolucaoParcialOrdemColeta(deliveries_ids, ordemColetaId, tpId)
      await getDevolucoesParciais()
      dispatch(showMessageBox('Associação Realizada Com Sucesso', null))
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      setBtnAssociarIsLoading(false)
    }
  }

  const onSelectionarTodosClicked = () => {
    const _devolucoes = [...devolucoes]
    _devolucoes.forEach(s => (s.selected = !selecionarTodos))
    setDevolucoes(_devolucoes)
    setSelecionarTodos(!selecionarTodos)
  }

  // Helpers
  const getDevolucoesParciais = async () => {
    try {
      setIsLoading(true)
      const fetchedDevolucoes = await getDevolucaoParcialPendentes(tpId, companyId, pInicial, pFinal)
      setDevolucoes(fetchedDevolucoes)
      setIsLoading(false)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }
  // Render
  return isLoading ? (
    <div className="text-center">
      <Loading />
    </div>
  ) : (
    <div>
      <div style={{ marginBottom: 15, marginTop: 10 }}>
        <Btn isLoading={btnAssociarIsLoading} onClick={onBtnAssociarClick}>
          Associar
        </Btn>
        <div style={{ display: 'inline-block', marginLeft: 16 }}>
          <CustomCheckbox checked={selecionarTodos} onChange={onSelectionarTodosClicked}>
            Selecionar Todos
          </CustomCheckbox>
        </div>
      </div>
      <DataTable
        paginator={true}
        rows={5}
        value={devolucoes}
        header={<CustomDataTableHeader value={globalFilter} onChange={setGlobalFilter} />}
        globalFilter={globalFilter}
        emptyMessage="Não existe Devoluções Parciais Pendentes"
      >
        <Column
          header=""
          style={tableCellCentered(80)}
          body={devolucao => (
            <CustomCheckbox
              checked={devolucao.selected}
              onChange={value => onItemClicked(devolucao, value)}
            />
          )}
        />
        <Column field="identifier" header="Identificador" style={tableCellCentered(120)} />
        <Column
          field="invoice_number_entrega"
          header="NF Entrega"
          style={tableCellCentered()}
          body={devolucao => {
            return devolucao.invoice_number_entrega ? (
              <TextBtn
                onClick={() => onNfEntregaIncluir(devolucao)}
                color="#333333"
                fontSize="14px"
              >
                {devolucao.invoice_number_entrega}
              </TextBtn>
            ) : (
              <TextBtn onClick={() => onNfEntregaIncluir(devolucao)} color={error}>
                Incluir
              </TextBtn>
            )
          }}
        />
        <Column field="razao_social" header="Razão" />
        <Column
          field="cnpj"
          header="CNPJ"
          style={tableCellCentered(170)}
          body={devolucao => <Cnpj>{devolucao.cnpj}</Cnpj>}
        />
        <Column field="city" header="Cidade" />
        <Column field="district" header="Bairro" />
        <Column
          field="qte_sku"
          header="Qte. Faltas"
          style={tableCellCentered(110)}
          body={dev => renderVolumeUnitsCell(dev.qte_sku_vol, dev.qte_sku_uni)}
        />
        <Column
          header="Menu"
          style={tableCellCentered(70)}
          body={devolucao => (
            <ThreeDots
              items={['Ocorrências', 'NF Devol. Parcial', 'Anexar Canhoto']}
              onClick={item => onMenuItemClicked(item, devolucao)}
            />
          )}
          bodyStyle={tableCellCentered()}
        />
      </DataTable>
      {showModalNfEntrega ? (
        <ModalNotaFiscalEntrega
          onSuccess={onModalNotaFiscalEntregaSuccess}
          onError={onModalNotaFiscalEntregaError}
          onModalClose={onModalNotaFiscalEntregaClose}
          deliveryId={selectedDevolucao.delivery_id}
          invoiceNumber={selectedDevolucao.invoice_number_entrega}
        />
      ) : null}
    </div>
  )
}

function ModalNotaFiscalEntrega({ deliveryId, invoiceNumber, onModalClose, onError, onSuccess }) {
  // Vars

  // Hooks
  const [nf, setNf] = useState(invoiceNumber)
  const [isLoading, setIsLoading] = useState(false)

  // Events
  const onModalSalvar = async () => {
    try {
      setIsLoading(true)
      if (!nf || (nf && nf.trim().length === 0))
        throw new Error('Número de Nota Fiscal de Entrega Incorreta')
      await atualizarNumNfEntrega(nf.trim(), deliveryId)
      onSuccess(deliveryId, nf)
    } catch (e) {
      onError(errorHandler(e))
    }
  }
  // Helpers

  // Render
  return (
    <CustomModal
      header={invoiceNumber ? 'Altere o Número da NF de Entrega' : 'Digite o Número da NF Entrega'}
      isVisible={true}
      onClose={onModalClose}
    >
      <form className="p-grid">
        <div className="p-col-12">
          <InputNumeroInteiro
            label="Número da Nota Fiscal de Entrega :"
            marginTop={10}
            value={nf}
            onChange={num => setNf(num)}
          />
        </div>
        <div className="p-col-12">
          <Btn isLoading={isLoading} onClick={onModalSalvar}>
            Salvar
          </Btn>
        </div>
      </form>
    </CustomModal>
  )
}

const mapStateToProps = ({ ordem_coleta: { identifier } }) => ({ selectedIdentifier: identifier })
export default connect(mapStateToProps)(withRouter(DevolucaoParcialPendente))
